import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';

export enum AskToCreateAccountEnum {
	SIGN_UP = 'sign_up',
	SIGN_IN = 'sign_in',
	NOTHING = null,
}

@Component({
	selector: 'app-ask-to-create-account-modal',
	templateUrl: './ask-to-create-account-modal.component.html',
	styleUrls: ['./ask-to-create-account-modal.component.scss'],
})
export class AskToCreateAccountModalComponent implements OnInit {
	public askToCreateAccountEnum = AskToCreateAccountEnum;
	public enterEmail = new FormControl('');

	constructor(private modalCtrl: ModalController) {}
	static async show(modalCtrl: ModalController): Promise<AskToCreateAccountEnum | string> {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height',
			component: AskToCreateAccountModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {}
	dismiss(value?: AskToCreateAccountEnum) {
		this.modalCtrl.dismiss(value);
	}
	login() {
		this.modalCtrl.dismiss('sign_in');
	}
	signUp() {
		this.modalCtrl.dismiss('sign_up');
	}
	asGuest() {
		this.modalCtrl.dismiss(this.enterEmail.value);
	}
}
